export default __webpack_public_path__ + "3328424635d3256835857cf33c53adf8.png";